<template>
    <div class="container pt-2">
        <PageTitle main="Status" sub="Cadastrar, alterar ou deletar Status" />
        <b-form>
            <input id="status-id" type="hidden" v-model="status.id" />
            <div class="row">
                <div class="col-md-12">
                    <b-form-group label="Titulo:" label-for="status-titulo">
                        <b-form-input id="status-titulo" type="text"
                            v-model="status.titulo"
                            placeholder="Informe o titulo do status."
                            :class="{ 'inputError': $v.status.titulo.$error }"
                            class="textInput"
                            @keydown.tab="$v.status.titulo.$touch"/>
                        <span class="error" v-if="!$v.status.titulo.required && $v.status.titulo.$error">Campo Obrigatório!</span>
                        <span class="error" v-if="!$v.status.titulo.minLength && $v.status.titulo.$error">Precisa ter no mínimo 3 caracteres!</span>
                    </b-form-group>
                </div>
            </div>
            <b-button variant="outline-success" class="botaoInput" @click="save">Salvar</b-button>
            <b-button variant="outline-danger" class="ml-2 botaoInput" @click="reset">Cancelar</b-button>
        </b-form>
        <hr>
        <div class="row justify-content-md-center">
            <span class="h3">Status</span>
        </div>
        <div class="row justify-content-md-center mb-3">
            <span class="h5">(Arraste e solte para alterar a ordem dos status)</span>
        </div>
        <div class="row mb-5 justify-content-md-center">
            <div class="col-md-12 ">
                <draggable :list="statuses.length>0?statuses:[]" class="list-group" ghost-class="ghost" :component-data="getComponentData()" v-if="statuses.length>0">
                    <div class="list-group-item" v-for="status in statuses" :key="status.titulo">
                        <i class="fa fa-align-justify handle mr-2"></i>
                        {{ status.titulo }}
                        <br v-if="larguraTela<400">
                        <b-button variant="danger" class="btn-sm" style="float: right;" @click="remove(status)">
                            <i class="fa fa-trash"></i>
                        </b-button>
                        <b-button variant="warning" class="mr-2 btn-sm" style="float: right;" @click="loadStatus(status)">
                            <i class="far fa-edit text-white"></i>
                        </b-button>
                    </div>
                </draggable>
                <draggable :list="statuses.length>0?statuses:[]" class="list-group" ghost-class="ghost" :component-data="getComponentData()" v-else>
                    <div class="list-group-item" v-for="status in statuses" :key="status.titulo">
                        <i class="fa fa-align-justify handle mr-5"></i>
                        <span class="text-custom"><i>Não há nenhum dado disponível!</i></span>
                    </div>
                </draggable>
                <!-- <div class="row" v-else>
                    <div class="col-md-12 text-center mb-3">
                        
                    </div> -->
                <!-- </div> -->
            </div>
        </div>



    </div>
</template>

<script>
import { baseApiUrl } from '@/global'
import axios from 'axios'
import PageTitle from '@/components/template/PageTitle'
import { mapState } from 'vuex'
import draggable from 'vuedraggable'
import { required, minLength } from 'vuelidate/lib/validators'
import { VueEasyJwt } from 'vue-easy-jwt'

export default {
    name: 'statuss',
    components: { PageTitle, draggable },
    data: function() {
        return {
            jwt: new VueEasyJwt(),
            level: '',
            status: {},
            statuses: [],
            qtd: '',
            fields: [
                { key: 'titulo', label: 'Título', sortable: true },
                { key: 'actions', label: 'Ações', thStyle: { width: '20%' } }
            ],
            larguraTela: 0
        }
    },
    validations: {
        status: {
            titulo: {
                required,
                minLength: minLength(4)
            }
        }
    },
    computed: mapState(['user']),
    methods: {
        handleChange() {
            this.statuses.forEach(this.changeOrdem)
        },
        changeOrdem(status){
            status.ordem = this.statuses.indexOf(status) + 1
            this.status = status
            this.save()
        },
        getComponentData() {
            return {
                on: {
                    end: this.handleChange
                }
            }
        },
        loadStatuses() {
            const url = `${baseApiUrl}/backend/status.php`
            axios.get(url).then(res => {
                this.statuses = res.data
                this.qtd = this.statuses.length
            })
        },
        reset() {
            this.status = {}
            this.loadStatuses()
            this.$v.status.$reset()
        },
        save() {
            this.$v.status.$touch()
            if(!this.$v.status.$error){
                const method = this.status.id ? 'put' : 'post'
                const id = this.status.id ? `?id=${this.status.id}` : ''
                this.status.final = '0'
                this.status.inicio = '0'
                if(this.status.ordem === this.qtd){
                    this.status.final = '1'
                }
                if(this.status.ordem === 1){
                    this.status.inicio = '1'
                }
                axios[method](`${baseApiUrl}/backend/status.php${id}`, this.status)
                    .then(() => {
                        if (method == 'post'){
                            this.$toasted.global.defaultSuccess({ message : 'Status inserido com sucesso!' })
                        } else {
                            this.$toasted.global.defaultSuccess({ message : 'Status alterado com sucesso!' })
                        }
                        this.reset()
                    })
                    .catch(
                        (e) => {
                        this.$toasted.global.defaultError({ message : e.response.data['dados'] })
                    }
                    )
            } else {
                this.$toasted.global.defaultError({ message : 'Verifique os campos!' })
            }
        },
        remove(status) {
            const sure = confirm("Deseja realmente excluir o status?")
            if(sure === true){
                const url = `${baseApiUrl}/backend/status.php`
                axios.delete(url, { data: status })
                    .then(() => {
                        this.$toasted.global.defaultSuccess({ message : 'Status excluído com sucesso!' })
                        this.reset()
                    })
                    .catch(
                        (e) => {
                        this.$toasted.global.defaultError({ message : e.response.data['dados'] })
                    }
                    )
            }
        },
        loadStatus(status) {
            this.status = { ...status }
        },
        validaLogin() {
            const local = localStorage.getItem('__SYSTEM_USER')
            const decodedToken = this.jwt.decodeToken(local)
            if (local === null) {
                this.$router.push({ path: '/login' })
            } else {
                this.level = decodedToken['data'].level
                this.quemRecebeu = decodedToken['data'].id
            }
        }
    },
    mounted() {
        this.validaLogin()
        if (this.level === 'cliente') {
            this.$router.push('/')
        } else if (this.level === 'motorista') {
            this.$router.push('/')
        }
        this.loadStatuses()
        this.larguraTela = screen.width - (screen.width * 0.08)
    }
}
</script>

<style>
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
.table {
    font-size: 0.9rem;
}

.textInput {
    border: 1px solid rgb(220, 220, 220);
    outline: 0 !important;
    border-radius: 0px !important;
    background-color: transparent !important;
    font-size: 0.8rem !important;
}

.botaoInput {
    font-size: 0.8rem !important;
    border-radius: 0px !important;
}

.error {
    color: #f57f6c;
    font-size: 0.6rem;
    padding-left: 10px;
}

.inputError {
    color: #f57f6c;
    border: 1px solid #f57f6c !important;
}

.btn-size {
    width: 30px;
    height: 30px;
    border-radius: 0;
}

.text-custom {
    font-size: 0.8rem;
}

.actionsTabela {
    max-width: 30px;
    vertical-align: middle;
}

.fieldsTabela {
    vertical-align: middle !important;
    font-size: 0.8rem;
}

.tituloTabela {
    font-weight: normal;
    font-style: italic;
    font-size: 0.9rem;
}

label {
    font-size: 0.8rem;
}
</style>